// extracted by mini-css-extract-plugin
export default {"wrapper":"WritingDataDisplay_wrapper__3r0V1","allEntriesContainer":"WritingDataDisplay_allEntriesContainer__7Wpxx","goalProgress":"WritingDataDisplay_goalProgress__cJ3ig"};